<template>
  <a-upload-dragger
    v-model:fileList="fileList"
    :headers="headers"
    name="file"
    :action="uploadAction"
    :data="{'biz':bizPath}"
    @change="handleChange"
    :showUploadList="false"
    :beforeUpload="beforeUpload"
    :multiple="false"
    :number="1"
  >
    <p class="ant-upload-drag-icon">
      <icon-font type="icon-shangchuantubiao" v-if="loading==0" style="font-size: 24px;"></icon-font>
      <icon-font type="icon-shangchuanzhong" v-if="loading==1" style="font-size: 24px;"></icon-font>
      <icon-font type="icon-shangchuanchenggong" v-if="loading==2" style="font-size: 24px;"></icon-font>
      <icon-font type="icon-shangchuanshibai" v-if="loading==3" style="font-size: 24px;"></icon-font>
    </p>
    <p class="ant-upload-text" v-if="loading==0">将文件拖拽此处</p>
    <p class="ant-upload-text" v-if="loading==1">正在上传中...</p>
    <p class="ant-upload-text" v-if="loading==2">上传成功!</p>
    <p class="ant-upload-text" v-if="loading==3">上传失败!</p>
    <!--<p class="ant-upload-hint">-->
      <!--Support for a single or bulk upload. Strictly prohibit from uploading company data or other-->
      <!--band files-->
    <!--</p>-->
  </a-upload-dragger>
</template>
<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { httpAction, getAction,getFileAccessHttpUrl  } from '@/api/manage'
import { getAccessToken } from '@/utils/token'

  const uidGenerator=()=>{
    return '-'+parseInt(Math.random()*10000+1,10);
  }
  const getFileName=(path)=>{
    if(path.lastIndexOf("\\")>=0){
      let reg=new RegExp("\\\\","g");
      path = path.replace(reg,"/");
    }
    return path.substring(path.lastIndexOf("/")+1);
  }
  export default {
    name: 'JUploadDragger',
    props: {
      /*这个属性用于控制文件上传的业务路径*/
      bizPath:{
        type:String,
        required:false,
        default:"temp"
      },
      value: {
        type: String,
        value: '',
      }
    },
    created(){
      const token = getAccessToken();
      //---------------------------- begin 图片左右换位置 -------------------------------------
      this.headers = {"X-Access-Token":token};
      //---------------------------- end 图片左右换位置 -------------------------------------
    },data(){
      return {
        uploadAction:window._CONFIG['domianURL']+"/sys/common/upload",
        headers:{},
        fileList: [],
        loading:0
      }
    },
    watch: {
      value(val) {
        this.value = val;
      },
    },methods: {
      handleChange (info) {
        const status = info.file.status;
        if (status !== 'uploading') {
          //console.log("uploading",info.file, info.fileList);
          this.loading = 1;
        }
        if (status === 'done') {
          this.$message.success(`上传成功!`);
          this.loading = 2;
          if(info.file.response.success){
            info.fileList.map((file) => {
              if (file.response) {
                let reUrl = file.response.message;
                reUrl = getFileAccessHttpUrl(reUrl);
                let fileName = info.file.name;
                let fileType = fileName.substring(fileName.lastIndexOf(".")+1,fileName.length);
                this.$emit("change",reUrl,fileName,fileType);
              }
            });
          }

        } else if (status === 'error') {
          this.$message.error(`${info.file.name} 上传失败!`)
          this.loading = 3;
        }
      },beforeUpload(file){
       this.loading = 1;
      },init(loading){
        this.loading = loading || 0;
      }
    }
  }
</script>
